/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import { useTranslate } from "../../hooks/useTranslate";

const StyledLabel = styled.label`
  margin: 0;
  font-size: calc(${({ theme }) => theme.fontSizes.p} * 0.875);
  line-height: 1.55;
  color: rgba(${({ theme }) => theme.colors.text.rgba});
`;

const RequiredSymbol = styled.span`
  color: rgba(${({ theme }) => theme.colors.error.rgba});
`;

const Label = ({ name, required, children, onClick, disableLabelClick, ...props }) => {
  const { _t } = useTranslate();

  return (
    <StyledLabel as={disableLabelClick ? "span" : "label"} htmlFor={disableLabelClick ? undefined : name} onClick={onClick} {...props}>
      {_t(children)}
      {required ? <RequiredSymbol>*</RequiredSymbol> : undefined}
    </StyledLabel>
  );
};

export default Label;
